var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:['ticket-priority ticket-priority--' + _vm.transformToModifierClass(_vm.value)]}),(_vm.withText)?_c('span',{staticClass:"ticket-priority__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }